"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PcView = void 0;
var _react = _interopRequireDefault(require("react"));
var _Select = require("../../../Select");
var _TimePicker = _interopRequireDefault(require("../TimePicker.styles"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var PcView = function PcView(props) {
  var defaultHourOption = props.defaultHourOption,
    defaultMinuteOption = props.defaultMinuteOption,
    hourOptions = props.hourOptions,
    minutesOptions = props.minutesOptions,
    onTimeChange = props.onTimeChange;
  var styles = (0, _TimePicker.default)(false, 'ellipse');
  var btnProps = {
    view: 'text',
    color: 'basic',
    size: 'small'
  };
  var handleHourSelection = function handleHourSelection(option) {
    onTimeChange(option.value, undefined);
  };
  var handleMinuteSelection = function handleMinuteSelection(option) {
    onTimeChange(undefined, option.value);
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: styles['cc-TimePicker'],
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Select.Select, {
        btnProps: btnProps,
        options: minutesOptions,
        isBoxCenteredToAnchor: true,
        arrowSpaceSize: "small",
        value: defaultMinuteOption,
        onChange: handleMinuteSelection
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      children: ":"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Select.Select, {
        btnProps: btnProps,
        options: hourOptions,
        isBoxCenteredToAnchor: true,
        arrowSpaceSize: "small",
        value: defaultHourOption,
        onChange: handleHourSelection
      })
    })]
  });
};
exports.PcView = PcView;